import { useBackHandle } from '@/hooks/useBackHandle';
import { useSlideBack } from '@/hooks/useSlideBack';
import React, { useEffect, useRef } from 'react';
import { Animated, ViewStyle } from 'react-native';
import { PanGestureHandler, State } from 'react-native-gesture-handler';
interface DragProps {
    style?: ViewStyle;
    visible?: boolean;
    onShouldClose?: () => void;
}
export const Drag = (props: React.PropsWithChildren<DragProps>) => {
    const { style, children, visible, onShouldClose } = props;
    const translateY = useRef(new Animated.Value(0)).current;
    const childSizeRef = useRef({
        width: 0,
        height: 0,
    });
    const { setSlideBack } = useSlideBack();
    useEffect(() => {
        if (typeof visible !== 'boolean') return;
        if (visible) {
            setSlideBack(false);
        } else {
            setSlideBack(true);
        }
    }, [visible]);
    useBackHandle(() => {
        if (typeof visible !== 'boolean') return;
        if (visible) {
            onShouldClose?.();
            return true;
        }
        return false;
    });

    const onGestureEvent = useRef(Animated.event([{ nativeEvent: { translationY: translateY } }])).current;
    const onHandlerStateChange = event => {
        if (event?.nativeEvent?.oldState === State.ACTIVE) {
            if (event.nativeEvent.translationY >= (childSizeRef.current.height * 0.5 || 200)) {
                // transY.setValue(childSizeRef.current.height);
                childSizeRef.current = {
                    width: 0,
                    height: 0,
                };
                translateY.setValue(1000);
                onShouldClose?.();
            } else {
                translateY.setValue(0);
            }
        }
    };
    return (
        <PanGestureHandler
            onGestureEvent={e => {
                if (e.nativeEvent.translationY < 0) return;

                onGestureEvent(e);
            }}
            onHandlerStateChange={onHandlerStateChange}>
            <Animated.View
                onLayout={e => {
                    if (childSizeRef.current.height) return;
                    childSizeRef.current = {
                        width: e.nativeEvent.layout.width,
                        height: e.nativeEvent.layout.height,
                    };
                }}
                style={[{ transform: [{ translateY }] }, style]}>
                {children}
            </Animated.View>
        </PanGestureHandler>
    );
};
